import {useCallback} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import '../../assets/styles/payment/publicPages.scss';
import usePageMeta from '../../services/page-meta';
import {resolveLocalePrefix, usePaymentPayload} from './helpers';

export default function DataProtectionPage() {
    const {t} = useTranslation();
    usePageMeta({
        title: t('meta.paymentDataProtection.title', t('payment.dataProtection.title')),
        description: t('meta.paymentDataProtection.description', t('app.description')),
        keywords: t('meta.paymentDataProtection.keywords', t('app.keywords')),
    });

    const history = useHistory();
    const location = useLocation();
    const {payload, isLoading} = usePaymentPayload('/api/v1/payment/data-protection');

    const handleGoBack = useCallback((event) => {
        event.preventDefault();

        if (window.history.length > 1) {
            history.goBack();
            return;
        }

        const localePrefix = resolveLocalePrefix(location.pathname);
        history.push(`${localePrefix}/`);
    }, [history, location.pathname]);

    if (isLoading || payload?.state !== 'active') {
        return <section className="payment-support-page payment-support-section" />;
    }

    return (
        <div className="payment-support-page">
            <section className="payment-support-section">
                <div className="container">
                    <div className="payment-header flex-center">
                        <div className="link-block">
                            <button type="button" className="payment-back-btn js-go-back" onClick={handleGoBack}>
                                {t('app.back')}
                            </button>
                        </div>
                        <h1>{t('payment.dataProtection.title')}</h1>
                    </div>
                    <div className="wrap">
                        <p dangerouslySetInnerHTML={{__html: t('payment.dataProtection.privacyPolicy')}} />
                        <h6>{t('payment.dataProtection.cardSecurity')}</h6>
                        <p>{t('payment.dataProtection.cardSecurityCaption')}</p>
                    </div>
                </div>
            </section>
        </div>
    );
}
